import i18n from 'i18n';
import {
  EnvironmentFields,
  InitialEnvironmentFields,
  EnvironmentUserConnection,
} from 'modules/environments/interfaces';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

/* eslint-disable @typescript-eslint/camelcase */
export interface SwitchComponentProps {
  children?: React.ReactNode;
  disabled?: boolean;
  explanationHover?: React.ReactNode;
  hidden?: boolean;
  hover?: string;
  id?: string;
  isChecked: boolean;
  label: string;
  tooltipTitle?: string;
  onChange: (e: any, value: any) => void;
}

export interface TitleDividerComponentProps {
  children: React.ReactNode;
  tooltipTitle?: string;
}

export const dictionaryDefaultPrimaryPortValues: Record<string, number> = {
  tsplus_all: 50491,
  tsplus: 50491,
  connect: 491,
  connect_direct: 491,
  tsplus_remote_app: 50491,
  aspw: 50491,
  aspw_all: 50491,
};

export const dictionaryDefaultSecondPortValues: Record<string, number> = {
  tsplus_all: 443,
  tsplus: 443,
  aspw: 443,
  aspw_all: 443,
};

export const WEB_PORT_VIRTUALIZERS = [
  'tsplus',
  'tsplus_all',
  'aspw',
  'aspw_all',
];

export const virtualizerStateKey = 'user_connection.virtualizer';
export const primaryPortStateKey = 'user_connection.service_port';
export const secondPortStateKey = 'user_connection.web_port';

export const changeFieldValueByVirtualizer = (
  key: string,
  value: string,
  setFieldValue: (key: string, value: number | boolean) => void
): void => {
  if (key !== virtualizerStateKey) return;

  setFieldValue(
    primaryPortStateKey,
    dictionaryDefaultPrimaryPortValues[value] || false
  );

  if (WEB_PORT_VIRTUALIZERS.includes(value)) {
    setFieldValue(
      secondPortStateKey,
      dictionaryDefaultSecondPortValues[value] || false
    );
  }
};

export const makeOptionsProductType = (
  field: GenericFormItem,
  productType: string,
  providerType: string
) => {
  if (field.stateKey === 'product_type') {
    const options = {
      autosky: [
        { value: 'dedicated', label: i18n.t('TYPE_DEDICATED_KEY') },
        { value: 'shared', label: i18n.t('TYPE_SHARED_KEY') },
        { value: 'manual', label: i18n.t('TYPE_MANUAL_KEY') },
        { value: 'period', label: i18n.t('TYPE_ROBOT_PERIOD_KEY') },
        { value: 'micro', label: i18n.t('TYPE_ROBOT_MICRO_KEY') },
      ],
      business_one: [
        { value: 'dedicated', label: i18n.t('TYPE_DEDICATED_KEY') },
        { value: 'shared', label: i18n.t('TYPE_SHARED_KEY') },
        { value: 'haas', label: i18n.t('TYPE_HAAS_KEY') },
        { value: 'ccc', label: i18n.t('TYPE_CCC_KEY') },
      ],
    };

    if (providerType !== 'oci') {
      options.autosky = [
        ...options.autosky,
        {
          value: 'spot_period',
          label: i18n.t('TYPE_ROBOT_PERIOD_SPOT_KEY'),
        },
      ];
    }

    return {
      ...field,
      options: options[productType] || [],
    };
  }

  return field;
};

export const getUserConnection = (
  environment: EnvironmentFields | InitialEnvironmentFields
): EnvironmentUserConnection => {
  const userConnection = environment?.user_connection;
  const webPort = userConnection?.web_port;
  const servicePort = userConnection?.service_port;
  const defaultServicePort =
    dictionaryDefaultPrimaryPortValues[userConnection?.service_port];

  const isInvalidType = (value?: string | number | null) =>
    [null, '', undefined, 0].includes(value);

  return {
    ...userConnection,
    web_port: isInvalidType(webPort) ? null : webPort,
    service_port: isInvalidType(servicePort) ? defaultServicePort : servicePort,
  };
};
